export const getHomepagePortfolioItems = (articles = []) =>
  articles.filter((article) => article?.featuredOnHomepage === true);
